import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import { Stack } from 'rsuite';

const Brand = props => {
  return (
    <Stack className="brand" {...props}>
      <Logo height={26} width={26} />
      <Link to="/">
        <span style={{ marginLeft: 14 }}>Stats Calculators</span>
      </Link>
    </Stack>
  );
};

export default Brand;
